const state = {
  user: {
    name: '',
    role: ''
  },
  routes: []
}

const mutations = {
  setUser(state, { usr_nm, perfil }) {
    state.user.name = usr_nm
    state.user.role = perfil
  },
  setRoutes(state, { routes }) {
    state.routes = routes
  },
  unsetData(state) {
    state.user = {
      name: '',
      role: ''
    }
  }
}

const actions = {
  newUser({ commit }, data) {
    commit('setUser', data)
  },
  newRoutes({ commit }, data) {
    commit('setRoutes', data)
  },
  clearData({ commit }) {
    commit('unsetData')
  }
}

const getters = {
  user: (state) => state.user,
  routes: (state) => state.routes
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
